var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgFavicon = function SvgFavicon(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 90 90"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#favicon_svg__a)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#0149FF",
    d: "M2.708 90q-1.032 0-1.934-.771Q0 88.329 0 87.3q0-.643.129-1.157L30.429 3.6q.388-1.414 1.548-2.443Q33.267 0 35.46 0H54.54q2.193 0 3.353 1.157 1.29 1.029 1.676 2.443l30.172 82.543Q90 86.657 90 87.3q0 1.029-.903 1.929-.773.771-1.934.771h-15.86q-1.933 0-2.965-.9-.903-1.029-1.16-1.8l-5.029-13.114H27.722l-4.9 13.114q-.258.771-1.16 1.8-.902.9-3.095.9zm30.506-34.286h23.572L44.873 21.43z"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "favicon_svg__a"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M0 0h90v90H0z"
  })))));
};
export default SvgFavicon;